import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { TypingInterval } from 'src/app/constants';

@Component({
  selector: 'app-user-id-filter',
  templateUrl: './user-id-filter.component.html',
  styleUrls: ['./user-id-filter.component.scss']
})
export class UserIdFilterComponent implements IFilterAngularComp {

  @ViewChild('eFilterText') eFilterText!: ElementRef;


  params: IFilterParams;

  filterText = '';

  typingTimer: any;

  doneTypingInterval = TypingInterval;

  destroySubscription = false;

  constructor() { }

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return this.filterText != null && this.filterText !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let passed = true;
    const { node } = params;
    // console.log(params);
    // this.filterText
    //     .toLowerCase()
    //     .split(' ')
    //     .forEach((filterWord) => {
    //         const value = this.params.rowModel.getRow;
    //       console.log(value)
    //         // if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
    //         //     passed = false;
    //         // }
    //     });
    const val = this.filterText.toLowerCase();
    if (!val) {
      passed = false;
    }

    return passed;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.filterText };
  }

  setModel(model: any) {
    this.filterText = model == null ? null : model.value;
  }

  onInputChanged() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      this.params.filterChangedCallback();
    }, this.doneTypingInterval);
  }

  destroy() {
    this.destroySubscription = true;
  }
}
